import styles from './style.module.css'
import { fetchLogo } from '../Splash/fetchLogo'
import * as Sentry from '@sentry/react'
import { platform } from '../../../core/services/device/platform'

interface ErrorPageOptions {
  connected?: boolean
  failedMicrofronts?: any[]
  error?: Error
}

export function renderInitErrorPage (options: ErrorPageOptions = {}): void {
  const element = document.createElement('div')
  element.classList = styles.splash

  const isWeb = platform === 'web'
  const { connected = true, failedMicrofronts = [] } = options

  Sentry.captureException(new Error('Pantalla de error de inicialización mostrada'), {
    tags: { platform, failedModules: failedMicrofronts.length }, extra: { error: options.error?.message }
  })

  const getErrorMessage = () => {
    if (!connected) return 'Sin conexión a internet. Verifique su conexión y reintente.'
    if (failedMicrofronts.length > 0) return `Error cargando ${failedMicrofronts.length} módulo(s). Presione "Reparar" para descargar las versiones actualizadas.`
    return isWeb
      ? 'La aplicación no puede inicializar correctamente. Intente recargar la página o contacte soporte si el problema persiste.'
      : 'La aplicación no puede inicializar correctamente, le pedimos revise su conexión o reinstale. En caso de continuar el error contáctese con soporte.'
  }

  const getActionButton = () => {
    if (failedMicrofronts.length > 0) {
      return `<button id="repair-button" onclick="window.repairModules()" class="${styles.repairButton}">Reparar Módulos</button>`
    }
    if (isWeb) {
      return `<button onclick="window.location.reload()" class="${styles.retryButton}">Reintentar</button>`
    }
    return ''
  }

  if (failedMicrofronts.length > 0) {
    (window as any).repairModules = async () => {
      const button = document.getElementById('repair-button') as HTMLButtonElement
      const progressContainer = document.getElementById('progress-container') as HTMLElement
      
      if (button) button.disabled = true
      if (progressContainer) progressContainer.style.display = 'block'
      
      try {
        const { downloadFailedModules } = await import('../../../index')
        await downloadFailedModules(failedMicrofronts, (progress) => {
          const progressBar = document.getElementById('progress-bar') as HTMLElement
          const progressText = document.getElementById('progress-text') as HTMLElement
          if (progressBar) progressBar.style.width = `${progress}%`
          if (progressText) progressText.textContent = `${Math.round(progress)}%`
        })
        window.location.reload()
      } catch (error) {
        console.error('Error downloading modules:', error)
        if (button) {
          button.disabled = false
          button.textContent = 'Error - Reintentar'
        }
      }
    }
  }

  fetchLogo()
    .then((url: string) => {
      element.innerHTML = `
        <img src="${url}" class="${styles.img}" />
        <div class="${styles.errorMessage}">
          <h2>Error de Inicialización</h2>
          <p>${getErrorMessage()}</p>
          ${getActionButton()}
          <div id="progress-container" class="${styles.progressContainer}" style="display: none;">
            <div class="${styles.progressBarContainer}">
              <div id="progress-bar" class="${styles.progressBar}"></div>
            </div>
            <span id="progress-text" class="${styles.progressText}">0%</span>
          </div>
        </div>
      `
    })
    .catch(() => {
      element.innerHTML = `
        <div class="${styles.errorMessage}">
          <h2>Error de Inicialización</h2>
          <p>${getErrorMessage()}</p>
          ${getActionButton()}
          <div id="progress-container" class="${styles.progressContainer}" style="display: none;">
            <div class="${styles.progressBarContainer}">
              <div id="progress-bar" class="${styles.progressBar}"></div>
            </div>
            <span id="progress-text" class="${styles.progressText}">0%</span>
          </div>
        </div>
      `
    })

  const rootElement = document.getElementById('root')
  if (rootElement != null) {
    rootElement.innerHTML = ''
    rootElement.appendChild(element)
  }
}
